import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppConstants } from 'src/app/shared/constants/app.contants';
import { AlertService, MessageSeverity } from 'src/app/shared/services/alert.service';
import { SensorService } from 'src/app/services/sensor/sensor.service';

@Component({
  selector: 'app-sensor-value-modal',
  templateUrl: './sensor-value-modal.component.html',
  styleUrls: ['./sensor-value-modal.component.css']
})
export class SensorValueModalComponent implements OnInit {

  sensorValueForm: FormGroup;
  headquarterSelect: number;
  headquarters = [];
  edit = false;
  colorSelect: string;

  constructor(
    public dialogRef: MatDialogRef<SensorValueModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private alertService: AlertService,
    private sensorService: SensorService,
    private spinner: NgxSpinnerService,
    public dialog: MatDialog,
  ) { }

  ngOnInit() {
    this.createForm();
    if(this.data.action == AppConstants.OperationType.UPDATE){
      this.edit = true;
      this.sensorValueForm.controls['name'].setValue(this.data.obj.name);
      this.sensorValueForm.controls['nomenclature'].setValue(this.data.obj.nomenclature);
      this.sensorValueForm.controls['und'].setValue(this.data.obj.und);
      this.sensorValueForm.controls['minValue'].setValue(this.data.obj.minValue);
      this.sensorValueForm.controls['maxValue'].setValue(this.data.obj.maxValue);
      this.sensorValueForm.controls['graph'].setValue(this.data.obj.graph);
      //this.sensorValueForm.controls['color'].setValue(this.data.obj.color);
      this.colorSelect = this.data.obj.color;
    }
  }

  createForm(){
    this.sensorValueForm = this.formBuilder.group({
      name: ['', [Validators.required,  Validators.maxLength(50)]],
      nomenclature: ['', [Validators.required,  Validators.maxLength(50)]],
      und: ['', [Validators.required,  Validators.maxLength(50)]],
      graph: ['', []],
      minValue: ['', []],
      maxValue: ['', []],
      color: ['', []],
    })
  }

  get f() { return this.sensorValueForm.controls; }

  save(){
    if(this.sensorValueForm.valid){
      const payload = {
        name:this.sensorValueForm.value["name"],
        nomenclature:this.sensorValueForm.value["nomenclature"],
        und:this.sensorValueForm.value["und"],
        graph: 0, //this.sensorValueForm.value["graph"],
        minValue:this.sensorValueForm.value["minValue"].toString(),
        maxValue:this.sensorValueForm.value["maxValue"].toString(),
        color: "#000000", //this.colorSelect,
        id: this.data.action == AppConstants.OperationType.UPDATE ? this.data.obj.id : 0,
        idSensor: this.data.idSensor,
        idUser: localStorage.getItem(AppConstants.Session.USERID)
      }
      this.spinner.show();
      if(this.data.action == AppConstants.OperationType.ADD){
        this.sensorService.createValue(payload).subscribe(_ => {
          if(!_.message){
            this.alertService.showMessage(AppConstants.TitleModal.CREATE_SENSOR_TYPE, AppConstants.MessageModal.CREATE, MessageSeverity.success);
            this.spinner.hide();
            this.data.result = true;
            this.dialogRef.close(this.data);
          }else{
            this.alertService.showMessage(
              _.message,
              "",
              MessageSeverity.error);
              this.spinner.hide();
          }
        });
      }else{
        this.sensorService.updateValue(payload).subscribe(_ => {
          if(!_.message){
            this.alertService.showMessage(AppConstants.TitleModal.UPDATE_SENSOR_TYPE, AppConstants.MessageModal.UPDATE, MessageSeverity.success);
            this.spinner.hide();
            this.data.result = true;
            this.dialogRef.close(this.data);
          }else{
            this.alertService.showMessage(
              _.message,
              "",
              MessageSeverity.error);
            this.spinner.hide();
          }
        });
      }
    }else{
      this.sensorValueForm.markAllAsTouched();
    }
  }


  close() {
    this.dialog.closeAll();
  }
}
